import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {LicenseAccessModuleDisableResultModal} from './license-access-module-disable.result.modal';
import {
    clearResult,
    selectLicenseAccessModuleDisableResultShown,
    selectLicenseAccessModuleDisableResultTask,
    selectLicenseAccessModuleDisableResultUuid,
} from './license-access-module-disable.slice';


export const LicenseAccessModuleDisableResult = () => (
    <BulkActionResult
        actionIdSelector={selectLicenseAccessModuleDisableResultUuid}
        actionTaskSelector={selectLicenseAccessModuleDisableResultTask}
        actionShownSelector={selectLicenseAccessModuleDisableResultShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <LicenseAccessModuleDisableResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
